import { apiClient } from './api';
import type {
  User,
  UserTenant,
  CreateUserRequest,
  UpdateUserRequest,
  AssignTenantPermissionRequest,
} from '../types/user';

export const userService = {
  getAll: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users');
    return response.data;
  },

  getUserTenants: async (userId: string): Promise<UserTenant[]> => {
    const response = await apiClient.get<UserTenant[]>(`/users/${userId}/tenants`);
    return response.data;
  },

  create: async (data: CreateUserRequest): Promise<string> => {
    const response = await apiClient.post<string>('/users', data);
    return response.data;
  },

  update: async (data: UpdateUserRequest): Promise<void> => {
    await apiClient.put(`/users/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  assignTenantPermission: async (data: AssignTenantPermissionRequest): Promise<void> => {
    await apiClient.post(`/users/${data.userId}/tenants/${data.tenantId}/permissions`, {
      userId: data.userId,
      tenantId: data.tenantId,
      permissionType: data.permissionType,
    });
  },

  removeTenantPermission: async (userId: string, tenantId: string): Promise<void> => {
    await apiClient.delete(`/users/${userId}/tenants/${tenantId}/permissions`);
  },
};












